import React, { Component } from 'react';
import { isEmpty, size } from 'lodash';
import Spin from '../../../../../commonModules/interface/Spin';
import Photos from '../../../../../commonModules/interface/input-files';
import InputText, { TextArea, InputSelect, InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import { TableRow, TableCell,Box, Button, TableHead, TableBody, IconButton,Typography, Grid } from '@material-ui/core';
import { TableLayout } from '../../containers/Layout';
import { CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons';
import {  toast } from 'react-toastify';
import PopUp from '../../../../../commonModules/interface/PopUp';
import { Alert } from '@material-ui/lab';
import Currency from '../../../../../commonModules/Currency';
const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })


class FormDetailsReturn extends Component {
    state = { 
        sale_ref: true,

        product_ref_display:{value: "", label: ""},
        product_location_display: {value: "", label: ""},
        client_ref_display: {value: "", label: ""},
        product_state_display: {value: "", label: ""},
        
        return_sale: "",
        return_sale_info:{},
        selected_product: "",
        return_product: {},
        maxQuantity: 0,

        product_ref: "",
        product_location: "",
        client_ref: "",
        product_state: "",
        product_quantity: "",
        description: "",
        use_length: "",
        sell_price: "",
        actual_price: "",
        product_photos: null,
        errors:{
            product_ref: "",
            client_ref: "",
            description: "",
            use_length: "",
            sell_price: "",
            actual_price: "",
            product_location: "",
            product_state: "",
            product_quantity: "",

        },
        sending: false,

    }

    createShopList = () => {
        const { SHOPS } = this.props
        let list = [{value: "", label: "Chosissez un Magasin"}]
        if( !isEmpty(this.props.SHOPS) ){// select shop options in Form
            Object.values(SHOPS).forEach( shop => { 
                list.push ({
                    value:shop.id, 
                    label:shop.name, 
                    disabled: (this.state.product_location === shop.id || !!shop.shop_disabled)
                })
            })
        }
        return list
    }
    setPhotos = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        this.setState({
            product_photos:list
        })
    }
    handleSelect = (option, name) => {
        let value = option.value
        let displayName = name +'_display'
        this.setState({
            [name]:value,
            [displayName]:option,
        })
    }

    
    handleChange = (e) => {
        const { name, value } = e.target
           
        this.setState({
            [name]:value,
        })
    }
    handleChangeProductQuantity = (e) => {
        const { name, value } = e.target
        var errors = this.state.errors
        console.log("[DEBUG], handleChangeProductQuantity, ", value, " vs , ",this.props.maxQuantity)
        if (value > this.props.maxQuantity){
            errors["product_quantity"] = "Quantité max est "+this.props.maxQuantity
            this.setState({
                errors: errors,
                [name]:this.props.maxQuantity,
            })
        }else{
            errors["product_quantity"] = ""
            this.setState({
                errors: errors,
                [name]:value,
            })
        }
    }
    
    validate = () => {
        let noErrors = true
        let errors = {}
        const required = [
            "product_quantity",
            "description",
            "use_length",
            "sell_price",
            "actual_price",
            "product_location",
            "product_state",
        ]
        const requiredProps = [
            "product_ref",
            "client_ref",
        ]
        required.map( field => {
            if(isEmpty(this.state[field])){
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
                
            }
        })
        requiredProps.map( field => {
            if(isEmpty(this.props[field])){
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
                
            }
        })
        
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        // return true
        return noErrors
    }

    handleSubmit = async () => {
        console.log("[DEBUG], handleSubmit, :> ",this.state)
        this.setState({sending: true})
        if(this.validate()){
            let data = {
                input_type: "sale_return",
                sale_id: this.props.return_sale,
                sale_item_id: this.props.currentSaleItem.id,
                client_ref: this.props.client_ref,
                product_ref: this.props.currentProduct.id,
                description: this.state.description,
                use_length: this.state.use_length,
                sell_price: this.state.sell_price,
                actual_price: this.state.actual_price,
                product_photos: this.state.product_photos,
                product_location: this.state.product_location,
                product_state: this.state.product_state,
                product_quantity: parseInt(this.state.product_quantity),
                product_status: "AVAILABLE"
            }
            let floats = [
                "use_length",
                "sell_price",
                "actual_price",
            ]
            floats.map( field => {
                data[field] = parseFloat(data[field])
            })
            console.log("Submit return", {data})
            //const response = await this.props.createReturnProduct(data)
            this.props.createReturnProduct(data).then(
                e => {
                    toast.success("Produit ajouté")
                    this.clearForms()
                    this.props.next()
                }
            ).catch( e =>{
                console.log("ERROR return", JSON.stringify(e))
                toast.error("ERROR "+JSON.stringify(e))
            })
        }
        this.setState({sending: false})
    }

    clearForms = () => {
        this.setState({
            product_ref_display:{value: "", label: ""},
            product_location_display: {value: "", label: ""},
            product_state_display: {value: "", label: ""},
            client_ref_display: {value: "", label: ""},
            
            product_ref: "",
            product_location: "",
            client_ref: "",
            product_quantity: "",
            product_state: "",
            description: "",
            use_length: "",
            sell_price: "",
            actual_price: "",
            product_photos: null,
            errors:{
                product_ref: "",
                client_ref: "",
                product_quantity: "",
                description: "",
                use_length: "",
                sell_price: "",
                actual_price: "",
                product_location: "",
                product_state: "",

            },
            sending: false,

        })
        this.setPhotos([])
    }
    render() {
        const { currentFormIndex, currentProduct, return_list, currentSaleItem } = this.props;
        return (
            <PopUp
                title={`Produit ${currentFormIndex}/${size(return_list)} | ${currentProduct.name} - ${currentProduct.marque}`}
                submitAction={this.handleSubmit}
                submitTitle="Suivant"
                close={this.props.previous}
            >
                <Box p={2}>
                    {this.state.sending && <Spin />}  
                    <Typography variant="subtitle2" >
                                Produit sélectionné : {this.state.return_product.name}
                            </Typography>

                    <Alert severity="info">
                        {currentProduct.name} - {currentProduct.marque} | <b>Prix Vente Unitaire: </b> <Currency value={currentSaleItem.sale_item_PU} /> | <b>Quantité restante: </b> {currentSaleItem.rest_to_return} / {currentSaleItem.quantity}
                    </Alert>                  
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <InputText 
                                type="number" 
                                id="product_quantity" 
                                onChange={this.handleChangeProductQuantity} 
                                value={this.state.product_quantity} 
                                name="product_quantity" 
                                title="Quantité"
                                error={this.state.errors.product_quantity}
                            />
                            <InputSelectMagasin
                                options={this.createShopList()}
                                value={this.state.product_location_display}
                                onChange={ option => this.handleSelect(option,"product_location")}
                                label="Magasin de retour"
                                error={this.state.errors.product_location}
                            /> 
                        
                            <TextArea
                                type="text" 
                                id="description" 
                                onChange={this.handleChange} 
                                value={this.state.description} 
                                name="description" 
                                title="Description"
                                placeholder="Description de l'état du produit"
                                rows={5}
                                error={this.state.errors.description}
                            />
                            
                            <Box p={1}>
                                <Photos photoList={this.setPhotos} photos={this.state.product_photos === null ? [] : this.state.product_photos }/>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputSelectMagasin
                                options={[
                                    {value:"new", label:"Comme Neuf"},
                                    {value:"very_good", label:"Très bien"},
                                    {value:"good", label:"Bien"},
                                    {value:"bad", label:"Mauvais"},
                                    //{value:"other", label:"..."},
                                ]}
                                value={this.state.product_state_display}
                                onChange={ option => this.handleSelect(option,"product_state")}
                                error={this.state.errors.product_state}
                                label="État du Produit"
                            /> 
                        
                            <InputText 
                                type="text" 
                                id="use_length" 
                                onChange={this.handleChange} 
                                value={this.state.use_length} 
                                name="use_length" 
                                placeholder="Durée d'utilisation en Mois"
                                title="Durée d'utilisation"
                                error={this.state.errors.use_length}
                            />

                            <InputText 
                                type="text" 
                                id="actual_price" 
                                onChange={this.handleChange} 
                                value={this.state.actual_price} 
                                name="actual_price" 
                                placeholder="Valeur du Produit"
                                title="Valeur Résiduelle du Produit"
                                error={this.state.errors.actual_price}
                            />
                            <InputText 
                                type="text" 
                                id="sell_price" 
                                onChange={this.handleChange} 
                                value={this.state.sell_price} 
                                name="sell_price" 
                                title="Prix de Revente Unitaire"
                                error={this.state.errors.sell_price}
                            />
                            
                            
                        </Grid>
                    </Grid>
                </Box>
            </PopUp>
        );
    }
}

export default FormDetailsReturn;